// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LQ-z","inlineTitle":"MQ-z","sponsoredAdsWrapper":"NQ-z","marketplaceRecosWrapper":"OQ-z"};